import request from '@/utils/request'

const PREFIX = '/signstore/party'

export function partySnapshot(params) {
  return request.get(PREFIX + '/snapshot', { params })
}

export function partyScreenBootstrap(params) {
  return request.get(PREFIX + '/screen/bootstrap', { params })
}
